<template>
  <div>

    <data-table
    ref="sitesways"
    table-ref="site_ways"

    title="Sites Ways"
    icon="fa fa-sort-numeric-up"
    hide-org-badge

    url="/view/sites/ways"

    trackBy="ways"
    sortField="ways"

    :fields="fields" />

 </div>

</template>

<script>

export default {

  props: {

    ways: {
      type: Number,
      default: null
    }
  },

  data () {
    return {
      fields: [
        {
          name: '__sequence',
          title: '#'
        },
        {
          name: 'ways',
          title: 'Ways',
        },
        {
          name: 'status',
          title: 'Status',
        },
        {
          name: 'siteId',
          title: 'Site ID',
        },
        {
          name: 'siteGroup',
          title: 'Site Group',
        },
        {
          name: 'coverage',
          title: 'Coverage',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'handover',
          title: 'Handover',
          callback: this.formatDate,
        },
        {
          name: 'postCode',
          title: 'Post Code',
        },
        {
          name: 'subdistrict',
          title: 'Sub District',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'state',
          title: 'State',
        },
        {
          name: 'country',
          title: 'Country',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'latitude',
          title: 'Latitude',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'

        },
        {
          name: 'longitude',
          title: 'Longitude',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'shortName',
          title: 'PM',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },

      ]
    }
  }
}

</script>
